import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import { cloneDeep, find } from "lodash";
import FormikInputField from "components/common/Fields/FormikInputField";
import { Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { ModuleAccess } from 'utils/moduleaccess';
import Loader from 'components/Loader';

import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import plus from "assets/icon/plus-icon.svg";

let hasDatePopupOpen = false;

let tableDataBackup = [
  // {
  //     chainPharmacy:"123445",
  //     pharmacy:"123445",
  //     npi:"123445",
  //     ncpdPandNABP:"123445",
  //     pharmacyAddress:"123445",
  //     pharmacyLiveDate:"123445",
  //     pharmacyTerminationDate:"123445",
  //     claimsProcessDate:"123445",

  // }
];
let rowForEdit = {};
let updatedFields = {};
let purchaseFlag = "PoFlag";
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";

let coveredEntitiesData = [];
let accumulationData = [];
let orderStatusData = [];
let accountTypeData = [];
let hospitalData = [];

const SearchContainer = (props) => {
  const {
    orgId,
    manvalPharmacy,
    onReset,
    onSearch,
    reset,
    ceid,
    setCeid,
    setLoading,
    tabKey

  } = props;
 
  const [tableData, setTableData] = useState(tableDataBackup);
  const [data, setData] = useState(tableDataBackup);
  const [showDetails, setShowDetails] = useState(true)
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [activeButton, setActiveButton] = useState("All");
  const [isSubmited, serIsSubmitted] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [orderStatus, setOrderStatus] = useState([]);
  const [selectedOrderStatus, setOrderStatusSelected] = useState(0);
  const [accountType, setAccountType] = useState([]);
  const [selectedAccountType, setAccountTypeSelected] = useState(0);
  const [poNum, setPONumber] = useState('');
  const [invoiceNum, setInvoiceNum] = useState('');
  const [hasACCSelected, setACCSelected] = useState(true);
  const [hasCESelected, setCESelected] = useState(true);
  const [hasHNselected, setHasHNselected] = useState("");
  const [selectedCEOption, setCEOptionSelected] = useState({ optionCESelected: "-1", });
  const [selectedACCOption, setOptionACCSelected] = useState({ optionACCSelected: "-1", });
  const [accuDisabled, setAccuDisabled] = useState(false);
  const API = useAxios();

  const {
    states: { searchOrder },
    setStates,
    resetStates,
  } = useContextService();
  const {
    coveredEntity,
    searchTerms,
    accumulations
  } = searchOrder
  let {
    coveredEntityIDs,
    coveredEntityID,
    accumulationIDs,
    orderStatusId,
    accountTypeId,
    poNumber,
    invoiceNumber,
    showClaimID,
  } = searchTerms;
  let addDisable = selectedCEOption.optionCESelected != '-1' && searchOrder.searchTerms.accumulationIDs.length == 1 && searchOrder.searchTerms.coveredEntityIDs.length > 0 && selectedACCOption.optionACCSelected != '-1' ? false : true;

  const updateStates = (searchOrder) => {
    setStates("SearchOrder", searchOrder);
  };
  useEffect(() => {
    fetchAccountType();
    fetchOrderStatus();
  }, []);

  useEffect(() => {
    setCESelected(true);
    setACCSelected(true);
    resetStates("searchOrder");
    coveredEntitiesData = [];
    accumulationData = [];
    hospitalData = [];
    searchOrder.searchTerms.coveredEntityIDs = {};
    searchOrder.searchTerms.accumulationIDs = {}
    searchOrder.accumulations = [];
    setAccuDisabled(false);
    updateStates(searchOrder);
    setCEOptionSelected({ optionCESelected: '-1' });
    setOptionACCSelected({ optionACCSelected: '-1' });
    setAccountTypeSelected('');
    setOrderStatusSelected('');
    setPONumber("");
    setInvoiceNum('');
    fetchCoveredEntities();
    serIsSubmitted(false);
  }, [orgId, reset]);



  const fetchCoveredEntities = async () => {
    //let { organizationID } = orgId;
    if(tabKey != "searchorder") return null;
    if (typeof orgId !== "undefined" && orgId !== null) {
      coveredEntitiesData = [];
      searchOrder.searchTerms.coveredEntityIDs = {};
      updateStates(searchOrder);

      let selectedOrgId = orgId.organizationID;

       setLoading(true);
      try {
        const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
          hasDefaultURL: true,
        });
        // setLoading(false);
        if (data) {
          for (var x in data) {
            coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
          }

          searchOrder.coveredEntities = data;

          if (coveredEntitiesData.length == 1) {
            var ceData = [];
            ceData.push(coveredEntitiesData[0])
            searchOrder.searchTerms.coveredEntityIDs = ceData;
            window.selectedCoveredEntittyId = ceData;
            setCeid(ceData)
          }
          if (window.selectedCoveredEntittyId.length > 0) {
            searchOrder.searchTerms.coveredEntityIDs =
              window.selectedCoveredEntittyId;
            setCeid(window.selectedCoveredEntittyId)

          }
          if (searchOrder.searchTerms.coveredEntityIDs) {

            var ceSelected = [];
            ceSelected.optionCESelected = [];
            for (var x in searchOrder.searchTerms
              .coveredEntityIDs) {
              ceSelected.optionCESelected.push(
                searchOrder.searchTerms.coveredEntityIDs[x]
              );
            }
            setCEOptionSelected(ceSelected);
            let ceIds = searchOrder.searchTerms.coveredEntityIDs.map(item => item["value"]);
            searchOrder.searchTerms.coveredEntityIDs = ceIds;
            setCeid(ceIds)
            fetchAccumulatorName(ceIds);
          }
          setLoading(false);
          updateStates(searchOrder);
        }
        setLoading(false);
      }
      catch (err) {
        setLoading(false);
      }
    }

  };
  const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
     
    let selected = [selectedces == null ? [] : selectedces]

    if (selected) {
      window.selectedCoveredEntittyId = selected;
      window.selectedAccumulatorId = [];

      accumulationData = [];
      // setSelectedNdc('');
      searchOrder.searchTerms.accumulationIDs = {};
      setCESelected(true);
      setCEOptionSelected({
        optionCESelected: selected.value
      });
      let val = selected.value;
      searchOrder.coveredEntities = selected;
      setFieldValue('coveredEntityIDs', selected);
      searchOrder.searchTerms.coveredEntityIDs = selected;
      if (Array.isArray(searchOrder.searchTerms.coveredEntityIDs)) {
        accumulationIDs = {};
        searchOrder.searchTerms.accumulationIDs = {};
      }
      let ceIds = searchOrder.searchTerms.coveredEntityIDs.map(item => item["value"]);
      searchOrder.searchTerms.coveredEntityIDs = ceIds;
      updateStates(searchOrder);
      setAccuDisabled(false);
      setHasHNselected("")
      fetchAccumulatorName(ceIds);
      setCeid(ceIds)
      setOptionACCSelected({ optionACCSelected: '-1' });
      hospitalData = [];
      // orderStatusData = [];
      // accountTypeData = [];
    //   setAccountTypeSelected(0);
    //   setOrderStatusSelected(0);

      setPONumber("");
    setInvoiceNum('');
    // setActiveButton('All');
    }
    else {
      setFieldValue('coveredEntityIDs', {});
      accumulationData = [];
      searchOrder.coveredEntities = [];
      searchOrder.searchTerms.coveredEntityIDs = {};
      searchOrder.searchTerms.accumulationIDs = {};
      setCESelected(false);
      setACCSelected(false);
    }
     onReset();
    updateStates(searchOrder);
  };
  const fetchAccumulatorName = async (coveredEntityIDs) => {
    debugger
    if (coveredEntityIDs !== undefined && coveredEntityIDs?.length > 0) {
      // setLoading(true);
      try {
        accumulationData = [];
        const payload = [];
        payload.AccumulatorEntityList = [coveredEntityIDs[0]];
        let AccumulatorEntityList = [payload.AccumulatorEntityList]
        const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
          {
            hasDefaultURL: true,
          }
        );
        if (result) {
          let accumulator = [];
          accumulator = result.data;
          for (var x in accumulator) {
            accumulationData.push({
              value: accumulator[x].accumulatorID,
              label: accumulator[x].ceName,
            });
          }
          if (accumulationData.length == 1) {
            handleAccumulatorname(accumulationData[0]);
          }
          // else if (window.selectedAccumulatorId.length > 0) {
          //   searchOrder.searchTerms.accumulationIDs =
          //     window.selectedAccumulatorId;
          //     handleAccumulatorname(window.selectedAccumulatorId[0]);
          // }


          // searchOrder.accumulations = result.data;
          updateStates(searchOrder);
          // if (accumulationIDs.length > 0) {
          //   var accumulatorSelected = {};
          //   accumulatorSelected.optionACCSelected = [];
          //   for (var x in accumulationIDs) {
          //     accumulatorSelected.optionACCSelected.push(
          //       accumulationIDs[x]
          //     );
          //   }
          //   setOptionACCSelected({ accumulatorSelected });
          //   // setLoading(false);
          // }
        }
      } catch (error) {
        // setLoading(false)
        console.log(error.message);
      }
    }
  };

  const handleAccumulatorname = (selectedces, setFieldValue, ac) => {

    let selected = [selectedces == null ? [] : selectedces]
    window.selectedAccumulatorId = selected;
    if (selected) {
      setACCSelected(true);
      setOptionACCSelected({
        optionACCSelected: selected
      })
      setAccuDisabled(true);
      // let val = selected.value;
      // setFieldValue('accumulatorID', val);
      // setFieldValue('accumulationIDs', selected);
      searchOrder.searchTerms.accumulationIDs = selected;
      hospitalData = []
      setPONumber("");
      setHasHNselected("")
      setInvoiceNum("");
      setAccountTypeSelected(0);
      setOrderStatusSelected(0);
      setActiveButton("All")
      fetchHospital(selected);
      handleSubmit();    
    }
    else {
      setACCSelected(true);
      setFieldValue('accumulationIDs', {});
      accumulationData = [];
      searchOrder.coveredEntities = [];
      searchOrder.searchTerms.accumulationIDs = {};
      searchOrder.searchTerms.coveredEntityIDs = {};
      setCESelected(false);
    }
    updateStates(searchOrder);
  };



  const fetchAccountType = async () => {
    accountTypeData = []
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, { hasDefaultURL: true });

      if (data) {

        for (var x in data) {
          accountTypeData.push({ "id": data[x].id, "description": data[x].description })
        }
        if (accountTypeId) {
          searchOrder.searchTerms.accountTypeId = accountTypeId;
          updateStates(searchOrder);
        }
        setAccountType(data);
      }
      else {
        setAccountType([]);
      }

    }

    catch (err) {

    }
  }
  const handleAccountTypeChange = (e, setFieldValue) => {

    const { value } = e.target;
    setFieldValue('accountTypeId', value);
    setAccountTypeSelected(value);
    searchOrder.searchTerms.accountTypeId = value;
    updateStates(searchOrder);
    console.log(value, "Account")
  };

  const fetchOrderStatus = async () => {
    orderStatusData = []
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/orderstatus`, { hasDefaultURL: true });

      if (data) {

        for (var x in data) {
          orderStatusData.push({ "id": data[x].id, "description": data[x].description })
        }
        if (orderStatusId) {
          searchOrder.searchTerms.orderStatus = orderStatusId;
          updateStates(searchOrder);
        }
        setOrderStatus(data);
      }
      else {
        setOrderStatus([]);
      }

    }
    catch (err) {

    }
  }
  const handleOrderStatusChange = (e, setFieldValue) => {

    const { value } = e.target;
    setFieldValue('orderStatusId', value);
    setOrderStatusSelected(value);
    searchOrder.searchTerms.orderStatusId = value;
    updateStates(searchOrder);
  };



  const handlePONUmberOnChange = (e, setFieldValue) => {
    const { value } = e.target;

    //setFieldValue('poNumber', value);
    setPONumber(value);
    searchOrder.searchTerms.poNumber = value;
    updateStates(searchOrder);
  };
  const handleInvoiceNumberOnChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue('invoiceNumber', value);
    setInvoiceNum(value);
    searchOrder.searchTerms.invoiceNumber = value;
    updateStates(searchOrder);
  };

  const handleHospitalChange = (e, setFieldValue) => {
     
    if (e) {
      const { value } = e.target;
      setFieldValue('hospitalDD', value);
      setHasHNselected(value);
      searchOrder.searchTerms.hospitalDD = value;
      updateStates(searchOrder);
    }



  }

  const handleSubmit = async () => {
    let acIDs = [];
    let ceIDs = [];

    for (var x in searchTerms.accumulationIDs) {
      var rw = searchTerms.accumulationIDs[x];
      acIDs.push(rw.value);
    }
    for (var x in searchTerms.coveredEntityIDs) {
      var rw = searchTerms.coveredEntityIDs[x];
      ceIDs.push(rw.value);
    }

    const values = {};
    if (ceIDs.length > 0) values.coveredEntityIDs = ceIDs;
    if (acIDs.length > 0) values.accumulationIDs = acIDs;

    if (ceIDs.length == 0) {
      setCESelected(false);

    }

    if (acIDs.length == 0) {
      setACCSelected(false);
    }

    values.AccountTypeID = searchTerms.accountTypeId;
    values.orderStatus = searchTerms.orderStatusId
    values.hasHNselected = hasHNselected;
    values.activeButton = activeButton;
    values.poNumber = poNum
    values.invoiceNumber = invoiceNum
    searchOrder.search.currentPage = 1;
    updateStates(searchOrder);
    await onSearch(values);
  }


  const handleReset = ({ resetForm }) => {
    serIsSubmitted(false);
    setCESelected(true);
    setACCSelected(true);
    setAccountTypeSelected('');
    setOrderStatusSelected('');
    setActiveButton('All');
    setHasHNselected("");
    setAccuDisabled(false)
    accumulationData = [];
    window.selectedCoveredEntittyId = "";
    window.selectedAccumulatorId = "";
    resetForm();
    onReset();
    setCEOptionSelected({ optionCESelected: "-1" });
    setOptionACCSelected({ optionACCSelected: "-1" });
    // setPONumber(null);
    setPONumber("")
    setInvoiceNum('');
    hospitalData = [];
    searchOrder.searchTerms.poNumber = '';
    searchOrder.searchTerms.coveredEntityIDs = {};
    searchOrder.searchTerms.accumulationIDs = {};
    searchOrder.searchTerms.accountTypeId = 0;
    setData([]);
    updateStates(searchOrder);
    resetStates("searchOrder");
  }

  const handleAllClick = (button) => {
    setActiveButton(button);

  };

  const handleManualClick = (button) => {
    setActiveButton(button)

  }
  const hasPermission = (code) => {
    return ModuleAccess("PCO", code);
  }
  const handleSystemClick = (button) => {
    setActiveButton(button)
  }



  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }


  const renderEditButton = () => {
    // if (hasPermission('EDT'))
    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'
      onClick={() => ""}
      title='Edit Covered Entity'

    >
      <HoverImage src={EditIcon}
        hoverSrc={EditHoverIcon}
        alt='' />
    </Button>
  }
  const cellRenderEdit = (rowData) => {

    if (rowData.isEdit) {
      return (
        <div className='d-flex align-items-center'>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={savePanelUpdateRow}
          >
            <HoverImage
              key='SaveIcon'
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=''
            />
          </Button>
          <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key='CancelIcon'
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=''
            />
          </Button>
        </div>
      );
    } else {

      return (
        <div className='d-flex align-items-center'>
          {renderEditLButton1(rowData)}

        </div>
      );
    }
  };
  const renderEditLButton1 = (rowData) => {
    // if (hasPermission('EPLS'))
    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'

      onClick={() => editRow(rowData)}
      title='Edit'


    >
      <HoverImage src={EditIcon}
        hoverSrc={EditHoverIcon}
        alt='' />
    </Button>
  }
  const editRow = (rowData, isEdit = true) => {

    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    // setTouched('');
    // setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setData(tempData);
  };
  const savePanelUpdateRow = async () => {
  };
  const updateRowValue = (value, col) => {

    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  const handelAdd = () => {
    setShowDetails(false)
  }
  const handelCancel = () => {
    setShowDetails(true)
  }
  useEffect(() => {

  }, [showDetails])
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {

    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const fetchHospital = async (selected) => {
    try {
      const { data } = await API.get(`SBConfig/coveredentity/hospitallist/${selected[0].value}/${purchaseFlag}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {

        for (var x in data) {
          hospitalData.push({ id: data[x].accountGroupName, description: data[x].accountGroupName })
        }
      }
    }
    catch {

    }
  }

  return (

    <div>


      <Formik
        initialValues={searchTerms}
        onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        // enableReinitialize={true}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div hidden={collapseSider}>
              <div>
                <div className="d-flex justify-content-between">
                  <h5 className="f-16 text-primary font-weight-700">
                    Search Purchase Order
                  </h5>
                  <Button
                    // hidden={isAddPermission}
                    // disabled={isSubmitting}
                    color="primary"
                    className="reset addbtn ms-3"
                    onClick={manvalPharmacy}
                    disabled={addDisable}
                    hidden={!hasPermission("AD")}
                    // disabled={!coveredEntityid}
                    // hidden={!hasPermission("ADD")}
                  >
                    <span className="right_5">
                      <img src={plus} alt="" />
                    </span>{" "}
                    Add
                  </Button>
                </div>
                <Row sm={5} className="d-flex" style={{}}>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="coveredentity">Covered Entity</Label>
                      <ReactSelect
                        name="coveredentity"
                        id="coveredentity"
                        options={coveredEntitiesData}
                        //isMulti
                        // closeMenuOnSelect={false}
                        // isClearable = {true}
                        // hideSelectedOptions={false}
                        // optionSelected={true}
                        components={{
                          Option,
                        }}
                        isSearchable="true"
                        onChange={(value, entity) =>
                          handleCoverdEntityChange(value, setFieldValue, entity)
                        }
                        value={selectedCEOption.optionCESelected}
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {!hasCESelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {coveredEntityError}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6} className="required-date">
                    {" "}
                    <FormGroup>
                      <Label for="accumulator">Accumulator</Label>
                      <ReactSelect
                        name="accumulator"
                        id="accumulator"
                        options={accumulationData}
                        isDisabled={accumulationData.length == 1}
                        //isMulti
                        // closeMenuOnSelect={false}
                        // isClearable ={true}
                        // hideSelectedOptions={false}
                        // optionSelected={true}
                        components={{
                          Option,
                        }}
                        onChange={(value, ac) =>
                          handleAccumulatorname(value, setFieldValue, ac)
                        }
                        value={selectedACCOption.optionACCSelected}
                        isSearchable="true"
                        className="claim_info required"
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                          option: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "flex-start",
                          }),
                        }}
                      />
                      {!hasACCSelected ? (
                        <div className="text-danger f-12 position-absolute">
                          {accumulationError}
                        </div>
                      ) : null}
                      {/* {(!hasACCSelected && isSubmited) ||
                                            (hasCESelected &&
                                              isSubmited &&
                                              selectedACCOption.optionACCSelected ==
                                                "-1") ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {accumulationError}
                                              </div>
                                            ) : null} */}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="hospitalname">Hospital Name </Label>
                      <Field
                        id="hospitalname"
                        name="hospitalname"
                        // className="required"
                        type="select"
                        placeholder="Select Hospital Name "
                        autoComplete="off"
                        options={hospitalData}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        optionSelected={true}
                        // hidden
                        value={hasHNselected}
                        component={FormikSelectField}
                        onChange={(e) => handleHospitalChange(e, setFieldValue)}
                        defaultoption="Select..."
                        keys={{
                          id: "id",
                          label: "description",
                        }}
                      />
                      {/* {hospitalErr && (
                                              <div className="text-danger font-size-12">
                                                {hospitalErr}
                                              </div>
                                            )} */}
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="accounttype">Account Type</Label>
                      <Input
                        defaultValue={0}
                        name="accounttype"
                        id="accounttype"
                        type="select"
                        value={selectedAccountType}
                        component={FormikSelectField}
                        onChange={(e) =>
                          handleAccountTypeChange(e, setFieldValue)
                        }
                      >
                        <option value={0}>(All)</option>
                        {accountTypeData.map((accountT) => {
                          const { id, description } = accountT;
                          return (
                            <option key={id} value={id}>
                              {description}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="orderStatus">Order Status</Label>
                      <Input
                        defaultValue={0}
                        name="orderStatus"
                        id="orderStatus"
                        type="select"
                        value={selectedOrderStatus}
                        component={FormikSelectField}
                        onChange={(e) =>
                          handleOrderStatusChange(e, setFieldValue)
                        }
                      >
                        <option value={0}>(All)</option>
                        {orderStatusData.map((status) => {
                          const { id, description } = status;
                          return (
                            <option key={id} value={id}>
                              {description}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="purchaseorder">Purchase Order</Label>
                      <Input
                        id="purchaseorder"
                        name="purchaseorder"
                        type="text"
                        placeholder="Enter PO Number"
                        autoComplete="off"
                        value={poNum}
                        component={FormikInputField}
                        onChange={(e) => {
                          handlePONUmberOnChange(e, setFieldValue);
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="invoiceNumber">Invoice #</Label>
                      <Input
                        id="invoiceNumber"
                        name="invoiceNumber"
                        type="text"
                        placeholder="Enter Invoice Number"
                        autoComplete="off"
                        value={invoiceNum}
                        component={FormikInputField}
                        onChange={(e) => {
                          handleInvoiceNumberOnChange(e, setFieldValue);
                        }}
                      />
                    </FormGroup>
                  </Col>

                  {/* <Col md={3} lg={3} sm={6} xs={6}>
                    {" "}
                    <FormGroup>
                      <Label for="">{""}</Label>

                      <ButtonGroup
                        className="buttongrpact"
                        style={{ marginTop: "27px",border:"none" }}
                      >
                        <Button
                          className="buttongrp"
                          color={
                            activeButton === "All"
                              ? "primary"
                              : "#702c62"
                          }
                          // backgroundcolor={activeButton==="Left"?"primary":"white"}
                          onClick={() =>
                            handleAllClick("All")
                          }
                        >
                          All
                        </Button>
                        <Button
                          className="buttongrp"
                          color={
                            activeButton === "Manual"
                              ? "primary"
                              : "#702c62"
                          }
                          // backgroundcolor={activeButton==="Middle"?"primary":"white"}
                          onClick={() =>
                            handleManualClick("Manual")
                          }
                        >
                          Manual
                        </Button>
                        <Button
                          className="buttongrp"
                          color={
                            activeButton === "System"
                              ? "primary"
                              : "#702c62"
                          }
                          // backgroundcolor={activeButton==="Right"?"primary":"white"}
                          onClick={() =>
                            handleSystemClick("System")
                          }
                        >
                          System
                        </Button>
                      </ButtonGroup>
                    </FormGroup>
                  </Col> */}
                  <Col md={3} lg={3} sm={6} xs={6}>
                    <FormGroup>
                      <Label for="buttonSelect">Order Type</Label>
                      <Input
                        type="select"
                        name="select"
                        id="buttonSelect"
                        value={activeButton}
                        onChange={(e) => {
                          if (e.target.value === "All") {
                            handleAllClick("All");
                          } else if (e.target.value === "Manual") {
                            handleManualClick("Manual");
                          } else if (e.target.value === "System") {
                            handleSystemClick("System");
                          }
                        }}
                      >
                        <option value="All">All</option>
                        <option value="Manual">Manual</option>
                        <option value="System">System</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div hidden={""}>
                <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
                  <Col md="auto" className="">
                    <Label>{""}</Label>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="search ms-3"
                      onClick={handleSubmit}
                      // disabled={!coveredEntityid}
                      // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5">
                        <img src={search} alt="" />
                      </span>{" "}
                      Search
                    </Button>
                    <Button
                      // hidden={isAddPermission}
                      // disabled={isSubmitting}
                      color="primary"
                      className="reset"
                      onClick={() => handleReset(props)}

                      // disabled={!coveredEntityid}
                      // hidden={!hasPermission("ADD")}
                    >
                      <span className="right_5">
                        <img src={reseticon} alt="" />
                      </span>{" "}
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
              {/* <hr /> */}
            </div>
          );
        }}></Formik>
      {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}


    </div>
  )
}

export default SearchContainer
